export const getQuerystring = (window: Window, key: string): string | null =>
  new URLSearchParams(window.location.search).get(key);
